<template>
  <div align="center">
    <v-content app class="fill-height fill-width">
      <v-container fluid>
        <v-row>
          <router-view />
        </v-row>
      </v-container>
    </v-content>
  </div>
</template>

<script>
export default {
  name: "Index",
  data: () => ({}),
  mounted() {},
};
</script>

<style></style>
